import { GridPosition100 } from '@at/track-types'

export const gridPosition = (gridPosition?: GridPosition | null): GridPosition100 | undefined => {
    if (gridPosition?.row && gridPosition.col) {
        return {
            SCHEMA_KEY: 'GridPosition100',
            row: gridPosition.row,
            col: gridPosition.col,
        }
    }
}

export interface GridPosition {
    row: number
    col: number
}

export function calculateGridPosition(
    trackingElement: HTMLDivElement | undefined,
    position: number | undefined
): GridPosition | null {
    if (trackingElement && position) {
        const gridItemElt = trackingElement.parentElement?.parentElement
        const gridElt = gridItemElt?.parentElement?.parentElement
        if (gridItemElt && gridElt) {
            const colSpan = parseInt(window.getComputedStyle(gridItemElt).gridColumnStart.split(' ')[1])
            const gridCols = window.getComputedStyle(gridElt).gridTemplateColumns.split(' ').length
            const totalCols = gridCols / colSpan
            const col = position % totalCols || totalCols
            const row = Math.ceil(position / totalCols)
            return { row, col }
        }
    }

    return null
}
